"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(range) {
  return function (WrappedComponent) {
    var NewComponent = /*#__PURE__*/function (_React$PureComponent) {
      _inheritsLoose(NewComponent, _React$PureComponent);

      function NewComponent(props) {
        var _this;

        _this = _React$PureComponent.call(this, props) || this;

        _defineProperty(_assertThisInitialized(_this), "onResize", function () {
          var size = _this.calculation();

          _this.setState({
            size: size
          });
        });

        _defineProperty(_assertThisInitialized(_this), "calculation", function () {
          if (!range) return {};
          var size = range["default"] || {};
          var width = document.body.clientWidth;

          for (var key in range) {
            if (key !== 'default') {
              if (key >= width) {
                size = range[key];
              }
            }
          }

          return size;
        });

        _this.state = {
          size: _this.calculation()
        };
        return _this;
      }

      var _proto = NewComponent.prototype;

      _proto.componentDidMount = function componentDidMount() {
        window.addEventListener('resize', this.onResize);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
      };

      _proto.render = function render() {
        var size = this.state.size;
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({
          size: size
        }, this.props));
      };

      return NewComponent;
    }(_react["default"].PureComponent);

    return NewComponent;
  };
};

exports["default"] = _default;
module.exports = exports.default;